import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { encryptStorage } from '../constant';

/**
 * PC_Mc_04 getMoodData gets imported from api.js file
 */
import { getDomainData, getMoodData } from '../service/api';

import { useNavigate } from 'react-router-dom';
import '../components/css/Dashboard-styles.css';
import moment from 'moment';

const data = [
    { name: 'Group D', value: 70 },
    { name: 'Group E', value: 30 },
];

const data2 = [
    { name: 'Group D', value: 20 },
    { name: 'Group E', value: 80 },
];

const data3 = [
    { name: 'Group D', value: 10 },
    { name: 'Group E', value: 90 },
];

let value = '100%';

const COLORS = ['#30C681', '#F7F5F2'];
const COLORS2 = ['#D9649C', '#F7F5F2'];
const COLORS3 = ['#4466D8', '#F7F5F2'];

export default function MoodData(props) {
    const navigate = useNavigate();

    /**
     * PC_Mc_02
     * The happyData , sadData ,okayData, currDate , role , domains, filterPressed , filterValue  state variable is created for storing the response data
     */

    const [happyData, setHappyData] = useState();

    const [sadData, setSadData] = useState();

    const [okayData, setOkayData] = useState();

    const [currDate, setCurrDates] = useState();

    const [role, setRole] = useState('');

    const [domains, setDomains] = useState([]);

    const filterObj = {
        domain: '',
        start_date: '',
        end_date: '',
    };
    const dates = {
        start_date: '',
        end_date: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    const [filterPressed, setFilterPressed] = useState(false);

    const [filterValue, setFilterValue] = useState('');
    const [date, setDate] = useState(dates);
    /**
     * PC_Mc_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        setRole(props.role);

        fetchApi();
    }, []);

    /**
     * PC_Mc_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getMoodData() function with respective parameters
     */

    const fetchApi = async (dataFilter = '') => {
        let resp;

        if (dataFilter.domain || (dataFilter.start_date && dataFilter.end_date)) resp = await getMoodData(dataFilter, props.role);
        else resp = await getMoodData('', props.role);

        let data;

        if (resp.data.ResponseData.length) {

            setCurrDates(resp.data.ResponseData[1]);

            const dateArray = resp.data.ResponseData[1].split(' - ');

            let startDate = moment(dateArray[0], 'DD MMM YYYY').format('YYYY-MM-DD');
            let endDate = moment(dateArray[1], 'DD MMM YYYY').format('YYYY-MM-DD');
            setDate((date) => ({
                ...date,
                start_date: startDate,
                end_date: endDate,
            }));
            if (resp?.data?.ResponseData[0]?.happy) {
                data = resp.data.ResponseData[0];
            } else {
                data = (resp.data.ResponseData[0]);
            }
        }

        setHappyData(data.happy);
        setSadData(data.sad);
        setOkayData(data.okay);

        const domainDrop = await getDomainData();

        if (domainDrop.data.ResponseData.length) setDomains(domainDrop.data.ResponseData);
    };

    const creatingData = (data, moodu) => {
        let val1 = 100 - Number(data);

        return [
            { name: moodu, value: Number(data) },
            { name: 'blank', value: val1 },
        ];
    };

    const filterClicked = () => {
        fetchApi(filterData);

        setFilterPressed(true);
    };

    /**
     * PC_Mc_10
     * The response happyDtaa, sadData , okayData gets stored in the data variable and passed to the PieChart
     */

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="ps-3">
                    <h1 className="tt-bold font-15 pt-3 mb-1">{role == 'Hr Manager' ? `Organization's Mood` : 'Team Mood'}</h1>
                    <p className="medium-text font-9 dash-grey">{`Mood Swing from ${currDate}`} </p>
                </div>
                <div className="dropdown m-2" style={{ 'z-index': '1' }}>
                    <button
                        className={`btn ${role == 'Hr Manager' ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
                        type="button"
                        id="dropdownMenuButton122"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {filterData.domain && filterPressed && filterData.domain != filterValue
                            ? `${filterValue}`
                            : filterData.domain && filterPressed
                                ? `${filterData.domain}`
                                : role == 'Hr Manager'
                                    ? `ALL`
                                    : null}
                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                    </button>
                    <div className="dropdown-menu dashboard-dashboard-filter-dropdown4 px-3 py-3">
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                <button className="btn p-0">
                                    <img src="/Images/Path 38820.svg" />
                                </button>
                            </div>

                            <div className="col-md-12">
                                {role == 'Hr Manager' ? (
                                    <>
                                        <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                        <select
                                            value={filterData.domain}
                                            onChange={(e) => {
                                                setFilterData((filterData) => ({
                                                    ...filterData,
                                                    [e.target.name]: e.target.value,
                                                }));
                                            }}
                                            className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                            name="domain"
                                        >
                                            <option selected value="">
                                                Select
                                            </option>
                                            {domains.map((domain) => {
                                                return <option value={domain}>{domain}</option>;
                                            })}
                                        </select>
                                    </>
                                ) : null}
                            </div>

                            <div className="row">
                                <h5 className="font-12 bold-text mt-3">Date Range</h5>
                                <div className="col-md-6">
                                    <label className="medium-text font-12 d-flex mb-1">From</label>
                                    <input
                                        value={filterData.start_date}
                                        max={filterData.end_date}
                                        onChange={(e) => {
                                            setFilterData((filterData) => ({
                                                ...filterData,
                                                ['start_date']: e.target.value,
                                            }));
                                            // let currentDate = currDate.split('-');

                                            // let startDate = moment(e.target.value, 'YYYY-MM-DD').format('DD MMM YYYY');
                                            // setCurrDates(`${startDate}-${currentDate[1]}`);
                                        }}
                                        type="date"
                                        className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                        placeholder="Select Domain"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="medium-text font-12 d-flex mb-1">To</label>
                                    <input
                                        onChange={(e) => {
                                            setFilterData((filterData) => ({
                                                ...filterData,
                                                ['end_date']: e.target.value,
                                            }));
                                            // let currentDate = currDate.split('-');

                                            // let startDate = moment(e.target.value, 'YYYY-MM-DD').format('DD MMM YYYY');
                                            // setCurrDates(`${currentDate[0]}-${startDate}`);
                                        }}
                                        value={filterData.end_date}
                                        min={filterData.start_date}
                                        type="date"
                                        className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                        placeholder="Select Domain"
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                                <a
                                    onClick={() => {
                                        setFilterData(filterObj);
                                        fetchApi();
                                        setFilterPressed(false);
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                >
                                    Clear
                                </a>
                                <button
                                    onClick={(e) => {
                                        filterClicked(e);
                                        setFilterValue(filterData.domain);
                                    }}
                                    type="button"
                                    className="btn hive-btn-primary dashboard-btn-filter"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ cursor: 'pointer' }}>
                <div>
                    <div style={{ 'margin-top': '-40px' }} className="row justify-content-between">
                        <div className="col-md-4" style={{ position: 'relative' }}>
                            <div className="text-center happy-mood-emojie">
                                <img
                                    src="/Images/dashboard-happy.png"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                    }}
                                />
                                <p className="font-15 tt-bold happy-mood-color">{happyData ? happyData : 0}%</p>
                                <p className="mt-4 bold-text font-11">Happy</p>
                            </div>
                            <PieChart className="happyPie" width={220} height={220} style={{ width: '100% !important' }}>
                                <Pie
                                    data={creatingData(happyData, 'happy')}
                                    cx={120}
                                    cy={200}
                                    innerRadius={65}
                                    outerRadius={80}
                                    fill="#30C681"
                                    paddingAngle={0}
                                    dataKey="value"
                                >
                                    {data.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={COLORS[index % COLORS.length]}
                                            onClick={() => {
                                                navigate('/moodgrid', { state: { filterData, mood: 'happy', date } });
                                            }}
                                        />
                                    ))}
                                </Pie>
                            </PieChart>
                        </div>
                        <div className="col-md-4" style={{ position: 'relative' }}>
                            <div className="text-center okay-mood-emojie">
                                <img
                                    src="/Images/dashboard-okay.png"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                    }}
                                />
                                <p className="font-15 tt-bold okay-mood-color">{okayData ? okayData : 0}%</p>
                                <p className="mt-4 bold-text font-11">Ok</p>
                            </div>
                            <PieChart className="happyPie" width={220} height={220} style={{ width: '100% !important' }}>
                                <Pie
                                    data={creatingData(okayData, 'okay')}
                                    cx={120}
                                    cy={200}
                                    innerRadius={65}
                                    outerRadius={80}
                                    fill="#D9649C"
                                    paddingAngle={0}
                                    dataKey="value"
                                >
                                    {data.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={COLORS3[index % COLORS3.length]}
                                            onClick={() => {
                                                navigate('/moodgrid', { state: { filterData, mood: 'okay', date } });
                                            }}
                                        />
                                    ))}
                                </Pie>
                            </PieChart>
                        </div>
                        <div className="col-md-4" style={{ position: 'relative' }}>
                            <div className="text-center sad-mood-emojie">
                                <img
                                    src="/Images/dashboard-sad.png"
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                    }}
                                />
                                <p className="font-15 tt-bold sad-mood-color">{sadData ? sadData : 0}%</p>
                                <p className="mt-4 bold-text font-11">Sad</p>
                            </div>

                            <PieChart className="happyPie" width={220} height={220} style={{ width: '100% !important' }}>
                                <Pie
                                    data={creatingData(sadData, 'sad')}
                                    cx={120}
                                    cy={200}
                                    innerRadius={65}
                                    outerRadius={80}
                                    fill="#4466D8"
                                    paddingAngle={0}
                                    dataKey="value"
                                >
                                    {data.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={COLORS2[index % COLORS2.length]}
                                            onClick={() => {
                                                navigate('/moodgrid', { state: { filterData, mood: 'sad', date } });
                                            }}
                                        />
                                    ))}
                                </Pie>
                            </PieChart>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
